import {signOutActionConstants} from './SignOutActionConstants'
import { HTTP, APIDirectory } from '../../rest';
export const signOutInProgress = () =>{
    return {
      type:signOutActionConstants.SIGNOUT_IN_PROGRESS
    }
  }
  export const signOutComplete = () =>{
    return {
      type:signOutActionConstants.SIGNOUT_COMPLETE
    }
  }


export const signOut = async (dispatch) => {
    try{
        dispatch(signOutInProgress());
        dispatch(signOutComplete())
       
    }catch(err){
       throw err;
    }
}